import {lazy} from 'react';

const AppointmentRescheduleSuccess = lazy(
  () => import('./AppointmentRescheduleSuccess'),
);

export default AppointmentRescheduleSuccess;
